module.exports = __webpack_public_path__ + "img/GAME_COLORPAPER1.66c9c0d9.jpg";